import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".chat-slash-command-content-widget{background-color:var(--vscode-chat-slashCommandBackground);border-radius:3px;color:var(--vscode-chat-slashCommandForeground);padding:1px}";
n(css,{});
export { css, css as default };
